import React, { useState } from 'react';
import { getAssetPath } from '../utils/paths';
import CalendlyButton from './CalendlyButton';
import './About.css';

const AboutPersonal = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    const funFacts = [
        {
            title: 'Fact 1',
            content: null,
            link: null,
            image: null
        },
        {
            title: 'Fact 2',
            content: null,
            link: null,
            image: null
        },
        {
            title: 'Fact 3',
            content: ['Content to be added'],
            link: null,
            image: null
        },
        {
            title: 'Fact 4',
            content: null,
            link: null,
            image: null
        }
    ];

    const handleImageClick = (imageSrc) => {
        setSelectedImage(imageSrc);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    return (
        <section id="about" className="about">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">About</h2>
                    <p className="section-subtitle">
                        Content to be filled in later
                    </p>
                </div>

                <div className="about-content">
                    {/* Profile Image Section */}
                    <div className="profile-image-section">
                        <img
                            src={getAssetPath('profile.jpg')}
                            alt="Profile"
                            className="profile-image"
                            onError={(e) => {
                                console.error('Image failed to load:', e.target.src);
                                // Try absolute path as fallback
                                e.target.src = '/pronurselegal/profile.jpg';
                            }}
                        />
                        <div className="profile-quote">
                            <blockquote>
                                "Content to be filled in later."
                            </blockquote>
                            <cite>— Author</cite>
                        </div>
                    </div>

                    <div className="about-text">
                        <div className="personal-info-card">
                            <h3>Personal Information</h3>
                            <div className="philosophy-section">
                                <p>
                                    Content to be filled in later.
                                </p>
                                <p>
                                    Content to be filled in later.
                                </p>
                                <p>
                                    Content to be filled in later.
                                </p>                                
                            </div>
                        </div>
                    </div>

                    <div className="leadership-principles">
                        <h3>Fun Facts</h3>
                        <div className="principles-grid">
                            {funFacts.map((fact, index) => (
                                <div key={index} className="principle-card">
                                    {fact.link ? (
                                        <a href={fact.link} target="_blank" rel="noopener noreferrer" className="fact-link">
                                            <h4>{fact.title}</h4>
                                        </a>
                                    ) : (
                                        <h4>{fact.title}</h4>
                                    )}
                                    {fact.content && Array.isArray(fact.content) ? (
                                        <ul className="strengths-list">
                                            {fact.content.map((strength, idx) => (
                                                <li key={idx}>{strength}</li>
                                            ))}
                                        </ul>
                                    ) : fact.content ? (
                                        <p>{fact.content}</p>
                                    ) : null}
                                    {fact.image && (
                                        <img
                                            src={fact.image}
                                            alt={fact.title}
                                            className="fact-image clickable-image"
                                            onClick={() => handleImageClick(fact.image)}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    
                    <div className="calendly-button-section">
                        <CalendlyButton />
                    </div>
                </div>
            </div>

            {/* Image Modal */}
            {selectedImage && (
                <div className="image-modal-overlay" onClick={closeModal}>
                    <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close-btn" onClick={closeModal}>×</button>
                        <img src={selectedImage} alt="Enlarged view" className="modal-image" />
                    </div>
                </div>
            )}
        </section>
    );
};

export default AboutPersonal;

